import { Chip, Grid, Stack } from "@mui/material";
import { memo } from "react";
import PropTypes from "prop-types";

// Component to render a single chip
export const MemoizedChip = memo(({ chipLabel, chipId, selected, handleClick }) => (
    <Chip
        label={chipLabel}
        variant={selected ? "filled" : "outlined"}
        onClick={() => handleClick(chipId)} // Pass ID to handleClick
        color={selected ? "success" : "default"}
        sx={{ backgroundColor: selected ? "success" : "transparent", color: selected ? "white" : "inherit", }}
    />
));

// Component to render a row of chips
export const ChipRow = memo(({ row, selectedChips, handleClick }) => (
    <Stack direction="row" spacing={2} mt={1}>
        {row.map(({ label, id }) => ( // Destructure to get label and id
            <MemoizedChip
                key={id} // Use ID as key
                chipLabel={label} // Render label
                chipId={id} // Pass ID
                selected={selectedChips.has(id)} // Check selection by ID
                handleClick={handleClick} // Handle click
                
            />
        ))}
    </Stack>
));
export const ChipRowTime = memo(({ row, selectedChips, handleClick }) => (
    <MemoizedChip
                key={row.id} // Use ID as key
                chipLabel={row.label} // Render label
                chipId={row.id} // Pass ID
                selected={row.id === selectedChips } // Check selection by ID
                handleClick={handleClick} // Handle click
              
            />
          
));
export const ChipRowTime2 = memo(({ row, selectedChips, handleClick }) => (

    <MemoizedChip
                  
                key={row.id} // Use ID as key
                chipLabel={row.label} // Render label
                chipId={row.id} // Pass ID
                selected={selectedChips.some(val=>val.JOB_DAY == row.id) } // Check selection by ID
                handleClick={handleClick} // Handle click
                
            />
           
          
));

ChipRow.propTypes = {
    row: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired
    })).isRequired, // Ensure row is an array of objects with label and ID
    selectedChips: PropTypes.instanceOf(Set).isRequired, // Ensure selectedChips is a Set
    handleClick: PropTypes.func.isRequired
};

MemoizedChip.propTypes = {
    chipLabel: PropTypes.string.isRequired,
    chipId: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired
};
